<h2 mat-dialog-title>{{ 'OTP_VERIFICATION.TITLE' | translate }}</h2>

<mat-dialog-content [formGroup]="form">
    <p class="otp-message">
        @if (mode === 'registration') {
        {{ 'OTP_VERIFICATION.MESSAGE_REGISTRATION' | translate }}
        } @else {
        {{ 'OTP_VERIFICATION.MESSAGE_LOGIN' | translate }}
        }
    </p>

    <mat-form-field appearance="outline" class="w-100 otp-field" style="margin-top: 1rem;">
        <mat-label>{{ 'OTP_VERIFICATION.CODE_LABEL' | translate }}</mat-label>
        <input matInput formControlName="otp" maxlength="6" placeholder="{{ 'OTP_VERIFICATION.CODE_PLACEHOLDER' | translate }}" required>
        @if (form.get('otp')?.hasError('required')) {
        <mat-error>{{'COMMON.FIELD_REQUIRED' | translate}}</mat-error>
        }
        @if (form.get('otp')?.hasError('minlength')) {
        <mat-error>{{ 'OTP_VERIFICATION.CODE_LENGTH_ERROR' | translate }}</mat-error>
        }
    </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end" class="otp-actions">
    <button mat-button (click)="cancelar()">{{ 'COMMON.BTN_CANCEL' | translate }}</button>
    <button mat-flat-button color="primary" (click)="verificar()" [disabled]="form.invalid">
        {{ 'OTP_VERIFICATION.VERIFY_BUTTON' | translate }}
    </button>
</mat-dialog-actions>

<div class="otp-resend">
    @if (resendCooldown > 0) {
    <span class="otp-countdown">{{ 'OTP_VERIFICATION.COUNTDOWN' | translate:{ seconds: resendCooldown } }}</span>
    } @else {
    <mat-label class="otp-resend-link" (click)="reenviar()">{{ 'OTP_VERIFICATION.RESEND_CODE' | translate }}</mat-label>
    }
</div>